import { JSX, useCallback } from "react";
import { useTranslation } from "react-i18next";

import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import MenuItem from "@mui/material/MenuItem";
import MenuList from "@mui/material/MenuList";

import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import PeopleOutlineIcon from "@mui/icons-material/PeopleOutline";

import { asTitle } from "utils/Utils";

import { MenuOptionKey, MenuOptions } from "./OrganisationMenuOptions";

export type OrganisationMenuProps = {
	selected: MenuOptionKey;

	onSelect: (option: MenuOptionKey) => void;
};

export default function OrganisationMenu(
	props: Readonly<OrganisationMenuProps>
): JSX.Element {
	const { t } = useTranslation();

	const selectGeneralOption = useCallback(
		() => props.onSelect(MenuOptions.GENERAL),
		[props.onSelect]
	);

	const selectMemberOption = useCallback(
		() => props.onSelect(MenuOptions.USERS),
		[props.onSelect]
	);

	return (
		<MenuList>
			<MenuItem
				selected={props.selected === MenuOptions.GENERAL}
				onClick={selectGeneralOption}>
				<ListItemIcon>
					<InfoOutlinedIcon fontSize="small" />
				</ListItemIcon>
				<ListItemText>{asTitle(t("general"))}</ListItemText>
			</MenuItem>
			<MenuItem
				selected={props.selected === MenuOptions.USERS}
				onClick={selectMemberOption}>
				<ListItemIcon>
					<PeopleOutlineIcon fontSize="small" />
				</ListItemIcon>
				<ListItemText>{asTitle(t("user_other"))}</ListItemText>
			</MenuItem>
		</MenuList>
	);
}
